import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.css']
})
export class CookiesComponent implements OnInit {

  public cookiesChoice: string;
  public isVisible: boolean;

  constructor() { }

  ngOnInit() {

    this.isVisible = true;
    if (this.getCookiesChoice()) {
      this.isVisible = false;
    }
  }

  setCookiesTrue() {
    localStorage.setItem('cookiesChoice', 'true');
    this.isVisible = false;
  }

  denyCookies() {
    localStorage.setItem('cookiesChoice', 'false');
    this.isVisible = false;
  }

  getCookiesChoice() {
    return localStorage.getItem('cookiesChoice');

  }

  isMobile = () => (window.innerWidth < 992) ? true : false;


}
